import React from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export function ButtonVolver({
  children = "⬅ Volver",
  className = "",
  type = "button",
  ...props
}: Props) {
  return (
    <button
      type={type}
      className={`
        ${className}

        flex
        items-center
        justify-center

        px-4
        py-1

        rounded-lg

        bg-zinc-900

    
        border-2
        border-zinc-500

        text-white
        font-medium

        whitespace-nowrap

        transition-all
        duration-300

        hover:border-cyan-500
        hover:bg-zinc-800
        hover:shadow-[0_0_20px_rgba(34,211,238,0.25)]
        
        active:scale-95
        active:border-none
        active:text-cyan-300
      `}
      {...props}
    >
      {children}
    </button>
  );
}

export default ButtonVolver;